<template>
  <div
      class="selectMenu"
  >
    <div class="text-wrapper">
      <div
          v-if="htmlMode"
          class="text"
          v-html="content"
      />
      <div
          v-else
          class="text"
      >
        {{ content }}
      </div>
    </div>
    <div class="button">
      <svg
          width="18"
          height="10"
          viewBox="0 0 18 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="icon"
      >
        <path
            d="M8.8544 9.99999C8.70026 10.0007 8.54754 9.97065 8.40518 9.91156C8.26283 9.85247 8.13371 9.76554 8.0254 9.65587L0.204629 1.83511C0.0486439 1.6069 -0.0217464 1.33094 0.00587241 1.0559C0.0334913 0.780865 0.157346 0.524413 0.355591 0.331778C0.553836 0.139144 0.813737 0.0227016 1.08946 0.00298839C1.36517 -0.0167248 1.639 0.0615578 1.86263 0.224029L8.8544 7.16887L15.8462 0.224029C16.0666 0.0810798 16.3287 0.0162909 16.5904 0.0400465C16.8521 0.0638021 17.0982 0.174727 17.2894 0.355041C17.4805 0.535356 17.6056 0.774618 17.6445 1.03448C17.6835 1.29434 17.634 1.55976 17.5042 1.78818L9.6834 9.60895C9.57912 9.72714 9.45181 9.82278 9.30925 9.89002C9.1667 9.95726 9.01192 9.99468 8.8544 9.99999Z"
            fill="white"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonSelector',
  props: {
    content: String,
    htmlMode: Boolean,
  },
};
</script>

<style scoped>
.selectMenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 17px;
  color: #666;
  cursor: pointer;
  border-radius: 5px;
  max-width: 205px;
  transition: box-shadow 0.3s, border-color 0.3s, background-color 0.3s;
}

.selectMenu:hover {
  box-shadow: 0 0 3px #333;
  background: #f9f9f9;
}

.text-wrapper {
  display: flex;
  background: white;
  align-items: center;
  flex-grow: 1;
  padding: 0 9px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  width: 165px;
  height: 32px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  text-overflow: ellipsis;
  border: 1px solid #DDD;
}

.text {
  flex-grow: 1;
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 32px;
  background: #839F22;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  transition: background-color 0.3s;
}

.selectMenu:hover .button {
  background: #91ad2c;
}

.icon {
  display: block;
}
</style>
